var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSubstraction = function SvgSubstraction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("path", {
    id: "Subtraction_44",
    "data-name": "Subtraction 44",
    d: "M10,20A10,10,0,1,1,20,10,10.013,10.013,0,0,1,10,20ZM5.955,9a1,1,0,1,0,0,2H8.949v3a1.015,1.015,0,0,0,1,1,12.156,12.156,0,0,0,2.709-2.295A12.5,12.5,0,0,0,14.955,10c0-.562-4.443-5-5-5a1,1,0,0,0-1,1V9Z",
    fill: "currentColor"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSubstraction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/substraction.13e33c40.svg";
export { ForwardRef as ReactComponent };